import styled from 'styled-components';

export const $Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

export const $BackButtonWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0.75rem;
`;

export const $BackButton = styled.button`
  padding: 0;
  font-size: 0.875rem;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const $StepTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 1rem;
  color: #334155;
`;

export const $StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const $ActionOption = styled.button`
  display: block;
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  font-size: 0.9375rem;
  background: #f4f6ff;
  border: 1px solid #ccd2f9;
  border-radius: 6px;
  color: #1e1b4b;
  cursor: pointer;
  transition:
    background-color 0.15s,
    border-color 0.15s;

  &:hover {
    background: #eef2ff;
    border-color: #5a72ff;
  }
`;

export const $List = styled.ul`
  margin: 0.75rem 0 0;
  padding-left: 1.25rem;
  color: #334155;
  font-size: 0.875rem;
  line-height: 1.5;
`;

export const $FieldBlock = styled.div`
  margin-top: 1.25rem;
`;

export const $FieldLabel = styled.div`
  margin-bottom: 0.4rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #334155;
`;

export const $RequiredMark = styled.span`
  color: #d32f2f;
  margin-left: 0.15rem;
`;

export const $Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
`;

export const $Hint = styled.p`
  margin: 0;
  color: #64748b;
  font-size: 0.875rem;
  line-height: 1.45;
`;

export const $PartLinesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

export const $PartLineCard = styled.div`
  padding: 1rem;
  border: 1px solid #ccd2f9;
  border-radius: 8px;
  background: #f8faff;
`;

export const $PartLineCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
`;

export const $PartLineCardTitle = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: #1e1b4b;
`;

export const $RemovePartLineButton = styled.button`
  padding: 0;
  font-size: 0.8125rem;
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #b91c1c;
  }
`;

export const $AddPartLineButtonWrap = styled.div`
  margin-top: 1rem;
`;
